export default "/images/vendor/flag-icons/flags/4x3/eg.svg?b0e8d940e81fd0adcd52738cb21598cd";